import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import zhCn from "element-plus/lib/locale/lang/zh-cn"
import "element-plus/theme-chalk/index.css"
import router from './router'
import axios from './plugins/axiosInstance'
import word_axios from './plugins/wordaxiosInstance'
import store from "./store"
import * as ElementPlusIconsVue from '@element-plus/icons-vue'


const app = createApp(App)
app.use(ElementPlus,{locale:zhCn,})
app.use(router)
app.use(store)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}

app.mount('#app')

app.config.globalProperties.$axios = axios
app.config.globalProperties.$wordaxios = word_axios